import * as actions from "./actionsTypes";

const initialData = {
  loaderCompetenciesDesc: false,
  loaderCompetenciesDescById: false,
  saveLoaderCompetenciesDesc: false,
  competenciesDesc: null,
  competencieDesc: null,
  competenciesDescError: "",
  competenciesDescFormError: "",
};

export default function CompetenciesDescReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADER_COMPETENCIES_DESC:
      return { ...state, loaderCompetenciesDesc: action.payload };
    case actions.LOADER_COMPETENCIES_DESC_BY_ID:
      return { ...state, loaderCompetenciesDescById: action.payload };
    case actions.SAVE_LOADER_COMPETENCIES_DESC:
      return { ...state, saveLoaderCompetenciesDesc: action.payload };
    case actions.GET_COMPETENCIES_DESC:
      return {...state,competenciesDesc: action.payload};
    case actions.GET_COMPETENCIES_DESC_BY_ID:
      return {...state, competencieDesc: action.payload};
    case actions.FORM_COMPETENCIES_DESC_FAIL:
      return { ...state, competenciesDescFormError: action.payload };
    case actions.COMPETENCIES_DESC_FAIL:
      return { ...state, competenciesDescError: action.payload };
    default:
      return state;
  }
}
